module.exports = __webpack_public_path__ + "img/jump.04f31c36.gif";